import FileSaver from "file-saver";
import { API_URL } from "../../config";
import { includes } from "lodash";
import PaymentContainerClient from "../../PaymentContainerClient";
import DocumentDto from "../../PaymentContainerClient/dtos/DocumentDto";
import isMobileOrTabletDevice from "../common/isMobileOrTabletDevice";

export const downloadDocument = async (
    token: string,
    document: DocumentDto
): Promise<void> => {
    // Warning: this check is needed because of Chrome and Firefox mobile's
    // browsers
    var isFileSaverSupported = !isMobileOrTabletDevice();
    if (isFileSaverSupported) {
        const paymentContainerClient = new PaymentContainerClient();
        const downloadedDocument =
            await paymentContainerClient.downloadDocument(
                token,
                document.documentId
            );

        const downloadedDocumentFilename = !document.description
            ? `document${document.documentId}.pdf`
            : !includes(".pdf", document.description)
            ? `${document.description}.pdf`
            : document.description;

        FileSaver.saveAs(downloadedDocument, downloadedDocumentFilename);
    } else {
        window.open(
            `${API_URL}api/v1/public/paymentRequest/${token}/documents/${document.documentId}/download`,
            "_self"
        );
    }
};
